import React from "react";
import {
  TBody,
  THead,
  TD,
  TH,
  TR,
  Tables,
} from "../../Components/AbstractsComponents/Tables";
import { Link } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { useWhiteLabels } from "../../Controllers/white-label";
import { ImFolderDownload } from "react-icons/im";

const WhiteLabels = () => {
  const {
    whiteLabels,
    loading,
    statusLoading,
    handleUpdateWhiteLabelStatus,
    setStatusLoading,
    downloadLoading,
    handleDownloadWhiteLabelAssets,
    setDownloadLoading,
  } = useWhiteLabels();

  const TableHead = [
    { title: "Name", callback: null, icon: null },
    { title: "Request By", callback: null, icon: null },
    // { title: "Email", callback: null, icon: null },
    { title: "Status", callback: null, icon: null },
    { title: "Created At", callback: null, icon: null },
    { title: "Actions", callback: null, icon: null },
  ];

  return (
    <>
      <div>
        {loading ? (
          <div className="flex items-center justify-center min-h-[70vh]">
            <TailSpin width={70} height={70} color={`blue`} />
          </div>
        ) : (
          <>
            <div className="flex flex-col w-full h-auto gap-6 py-8">
              <div className="flex justify-between">
                <h3 className="text-left font-semibold  text-[#566589]">
                  App Customization
                </h3>
              </div>
              <div className="bg-white min-h-[70vh]    rounded-3xl">
                <Tables>
                  <THead>
                    <TR>
                      {TableHead.map((ls, index) => (
                        <TH
                          className={`${
                            ls === "Actions"
                              ? "sticky right-0 rounded-tr-2xl bg-gray-400 z-10 text-white"
                              : ""
                          }  whitespace-nowrap cursor-pointer`}
                          key={index}
                          onClick={ls?.callback}
                        >
                          <div className="flex items-center gap-2">
                            {ls.title} <span>{ls.icon}</span>
                          </div>
                        </TH>
                      ))}
                    </TR>
                  </THead>
                  {whiteLabels.length > 0 ? (
                    <TBody className={`relative`}>
                      {whiteLabels?.map((whiteLabel, index) => {
                        return (
                          <TR key={index}>
                            <TD>{whiteLabel?.name}</TD>
                            <TD>{whiteLabel?.rootBusiness?.fullName}</TD>
                            {/* <TD>{whiteLabel?.rootBusiness?.email}</TD> */}
                            <TD>
                              <span
                                className={`capitalize ${
                                  whiteLabel?.status === "pending"
                                    ? "text-yellow-500 font-mono px-3 py-1 max-h-max max-w-max text-xs bg-yellow-200 rounded-full"
                                    : "text-green-500 px-3 py-1 max-h-max max-w-max text-xs bg-green-200 rounded-full"
                                }`}
                              >
                                {whiteLabel?.status}
                              </span>
                            </TD>
                            <TD>
                              {new Date(
                                whiteLabel?.createdAt
                              ).toLocaleDateString()}
                            </TD>
                            <TD
                              className={`sticky inset-y-0 my-auto right-0  `}
                            >
                              <div className="flex items-center h-full gap-2">
                                <button
                                  onClick={() => {
                                    handleDownloadWhiteLabelAssets(
                                      whiteLabel?._id,
                                      whiteLabel?.name
                                    );
                                    setDownloadLoading(whiteLabel?._id);
                                  }}
                                  className="px-3 py-2 font-semibold flex items-center gap-2 text-center text-white no-underline rounded-lg bg-primary"
                                >
                                  {downloadLoading === whiteLabel?._id ? (
                                    <TailSpin
                                      width={15}
                                      height={15}
                                      color={`white`}
                                    />
                                  ) : (
                                    <ImFolderDownload size={15} />
                                  )}
                                  Download Assets
                                </button>
                                <select
                                  className="h-10 w-[120px] font-semibold text-center rounded-lg border border-gray-300 bg-white"
                                  defaultValue={whiteLabel?.status}
                                  onChange={(e) => {
                                    setStatusLoading(whiteLabel?._id);
                                    handleUpdateWhiteLabelStatus(
                                      whiteLabel?._id,
                                      e.target.value
                                    );
                                  }}
                                >
                                  <option value="pending">Pending</option>
                                  <option value="inProgress">
                                    In Progress
                                  </option>
                                  <option value="completed">Completed</option>
                                </select>
                                <div className="w-10">
                                  {statusLoading === whiteLabel?._id && (
                                    <TailSpin
                                      width={15}
                                      height={15}
                                      color={`blue`}
                                    />
                                  )}
                                </div>
                              </div>
                            </TD>
                          </TR>
                        );
                      })}
                    </TBody>
                  ) : (
                    <div className="text-center text-lg font-semibold text-[#566589]">
                      No White Label Records Found
                    </div>
                  )}
                </Tables>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default WhiteLabels;
